//import { getUserData } from 'app/store/actions/user/user.actions';
import axios from 'axios';

export const GET_COMPANY = '[CONTACTS APP] GET COMPANY';
export const SIDE_MENU_ITEMS = '[COMPANY APP] CREATE SIDEMENU ITEMS';
export const POST_SIDE_MENU_ITEMS = '[COMPANY APP] CREATE SIDEMENU ITEMS';
export const GET_SIDE_MENU_ITEMS = '[COMPANY APP] GET SIDEMENU ITEMS';
export const RESET_SIDE_MENU_ITEMS = '[COMPANY APPP] RESER MENU ITEM';
export const MEMBER_SEARCH_TEXT = '[CONTACTS APP] MEMBER SEARCH TEXT';
export const OPEN_NEW_CONTACT_DIALOG = '[CONTACTS APP] OPEN NEW CONTACT DIALOG';
export const CLOSE_NEW_CONTACT_DIALOG = '[CONTACTS APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_CONTACT_DIALOG = '[CONTACTS APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_CONTACT_DIALOG = '[CONTACTS APP] CLOSE EDIT CONTACT DIALOG';
export const ADD_CONTACT = '[CONTACTS APP] ADD CONTACT';
export const UPDATE_CONTACT = '[CONTACTS APP] UPDATE CONTACT';
export const REMOVE_CONTACT = '[CONTACTS APP] REMOVE CONTACT';
export const REMOVE_CONTACTS = '[CONTACTS APP] REMOVE CONTACTS';
export const TOGGLE_STARRED_CONTACT = '[CONTACTS APP] TOGGLE STARRED CONTACT';
export const TOGGLE_STARRED_CONTACTS = '[CONTACTS APP] TOGGLE STARRED CONTACTS';
export const SET_CONTACTS_STARRED = '[CONTACTS APP] SET CONTACTS STARRED ';
export const COMPANY_NAME = '[CONTACTS APP] SET COMPANY NAME';
export const CREATE_HEAD_ADMIN_LIST = '[CONTACTS APP] CREATE HEAD ADMIN LIST';
export const HEAD_ADMIN_NAME = '[CONTACTS APP] SET HEAD ADMIN NAME';
export const SET_IMG_HEAD_ADMIN = '[CONTACTS APP] SET IMG HEAD ADMIN';
export const HANDLE_FILES_UPLOAD = '[CONTACTS APP] HANDLE FILES UPLOAD';
export const HANDLE_FILES_UPLOAD_LIST = '[CONTACTS APP] HANDLE FILES UPLOAD FROM ADDED LIST';
export const HANDLE_DETAILS = '[CONTACTS APP] HANDLE DETAILS';
export const CREATE_COMPANY = '[CONTACTS APP] CREATE COMPANY';
export const FLAG_CLICK_COMPANIES = '[NAVIGATION] FLAG CLICK COMPANIES';
export const SET_FILTER_CHECKBOX = '[COMPANIES APP] FILTER CHECKBOX';
export const HANDLE_IMAGE_EDIT = '[COMPANIES APP] EDIT IMAGE';
export const HANDLE_EDIT_DETAILS = '[COMPANIES APP] EDIT COMPANY DETAILS';
export const HANDLE_UPDATE_COMPANY = '[COMPANIES APP] UPDATE COMPANY';
export const HANDLE_REMOVE_COMPANY = '[COMPANY APP] REMOVE COMPANY';
export const CLICK_REMOVE_COMPANY = '[CLICK REMOVE COMPANY] CLICK REMOVE COMPANY';
export const HANDLE_ACTIVATE_COMPANY = '[COMPANY APP] HANDLE_ACTIVATE_COMPANY';
export const IS_EDITABLE = '[COMPANY APP] IS EDITABLE';
export const ADD_COMPANY_BUTTON = '[COMPANY APP] BUTTON ADD COMPANY';
export const HANDLE_COMPANY_RESPONSE = '[COMPANIES APP] COMPANY RESPONSE';
export const GET_HEAD_ADMIN = '[COMPANIES APP] GET HEAD ADMIN API';
export const REMOVE_HEAD_ADMIN = '[COMPANIES REMOVE HEAD ADMIN] REMOVE HEAD ADMIN';
export const CLICK_REMOVE_HEAD_ADMIN = '[COMPANIES CLICK REMOVE HEAD ADMIN] CLICK REMOVE HEAD ADMIN';
export const CLICK_CREATE_HEAD_ADMIN = '[COMPANIES CLICK CREATE HEAD ADMIN] CLICK CREATE HEAD ADMIN';
export const VALID_DOMAIN = '[COMPANIES APP] VALID_DOMAIN';
export const SEARCH_COMPANY_USERS = '[COMPANIES APP] SEARCH COMPANY USERS';
export const CREATE_COMPANY_MODE = '[COMPANIES APP] MODE CREATE COMPANY';
export const IS_SUBMITED_MODE = '[COMPANIES APP] IS SUBMITED MODE';
export const CREATE_COMPANY_FLAG = '[COMPANIES APP] FLAG FOR CREATE COMPANY PAGE';



//::GET COMPANIES
export function getCompany(pageData, _searchText) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		let localStoragePage = localStorage.getItem('pageData');
		let page = localStoragePage ? localStoragePage : 1;
		let searchText = _searchText;
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		if(pageData){
			page = pageData;
		}

		if(!searchText){
			searchText = '';
		}

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/company/?page=' + page + '&search=' + searchText, headersToken)
		
		return request.then(response => {
			console.log('Create Companies successfully', response.data);
			dispatch(addPost(''));
			return dispatch({
				type: GET_COMPANY,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not load data from companies', error);
			dispatch(addPost(''));
		})
	};
}


//:: SideMenu Items
export function sideMenuItems() {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		let companyID = localStorage.getItem('persistCompanyID');
		if(!companyID){
			companyID = null;
		}
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/sideMenu/side-menu-list?companyID=' + companyID, headersToken)
		
		return request.then(response => {
			console.log('Load Side Menu Items Succesfully!', response.data);
			return dispatch({
				type: SIDE_MENU_ITEMS,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not load Side Menu Items', error);

		})
	};
}

//::Create SideMenu Items
export function createSideMenuItems(dataUUID) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		console.log(' UUIID ARRAY HERE : ', dataUUID)
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/sideMenu/side-menu-handler', {
			companyID : localStorage.getItem('persistCompanyID'),
			menuItems : [...dataUUID],
		}, headersToken)
		
		return request.then(response => {
			console.log('Created Side Menu Items Succesfully!', response);
			return dispatch({
				type: POST_SIDE_MENU_ITEMS,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not create Side Menu Items', error);

		})
	};
}


//::GET Choosen Side Menu Items
export function getSideMenuItems(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user && current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		let companyID = '';

		if(data){
			companyID = data;
		}else{
			companyID = localStorage.getItem('persistCompanyID');
		}
		
		let project_uuid = localStorage.getItem('persistProjectUUID');
		if(!project_uuid || project_uuid === null){
			project_uuid = '';
		};

		//console.log('SELECTED PROJECT UUID : ', project_uuid)
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/sideMenu/side-menu-handler?companyID=' + companyID +  '&project_uuid=' + project_uuid, headersToken)
		
		return request.then(response => {
			//console.log('GOT Side Menu Items Succesfully!', response.data);
			return dispatch({
				type: GET_SIDE_MENU_ITEMS,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not get Side Menu Items', error);

		})
	};
}


//::Reset Menu Item
export function resetSideMenuItem(){
	return{
		type: RESET_SIDE_MENU_ITEMS,
	}
}


//::Get Head Admin
export function getHeadAdmin(data,inputData){
	return async (dispatch) => {
		console.log('GET Head Admin Company ID -->', data);
		console.log('Search Key --->', inputData)
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			headers: {"Authorization": `Token ${token}`}
		};
		let searchKey = inputData;
		const companyID = data;
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/member/companyHeadAdmin?companyID='+companyID+'&searchKey='+searchKey, headersToken );

		// const request = axios({
		// 	method: 'get',
		// 	url: 'http://127.0.0.1:8000/api/member/companyHeadAdmin',
		// 	params:{companyID : data},
		// 	headers: {"Authorization": `Token ${token}`}
		// })
		
		return request.then(response => {
			console.log(response.data, 'Get Head Admin Succesfully');
			dispatch(addPost(''));
			return dispatch({
				type: GET_HEAD_ADMIN,
				payload: response.data,
			});
		})
		.catch( error =>{
			console.log(error.response, 'Error to Get Head Admin')
			dispatch(addPost(''));
		})
	};
}

//::Create Company
export function createCompany(data){
	return async(dispatch) =>{
		const current_user = JSON.parse(localStorage.getItem('current_user'));
		const token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/company/', data, headersToken );
		return request.then((response) => {
			console.log(response.data, 'Created Company Succesfully');
			dispatch(addPost(response.data));
			dispatch(handleEditDetails(response.data.data))
			dispatch(getCompany());
			return dispatch({
				type: CREATE_COMPANY,
				payload: data,
			})

		})
		.catch((error => {
			dispatch(addPost(error.response.data));
			console.log(error.response, 'Post error')
		}))
	}
}

//::Search Company Users
export function searchCompanyUsers(companyId,inputData){
	return async (dispatch)=>{
		const request = fetch(inputData);
		console.log('EMAIL SEARCH -->', request)
		return request.then(response =>{
			dispatch(getHeadAdmin(companyId,inputData));
			console.log('Succesfully search', response)
			return{
				type:SEARCH_COMPANY_USERS,
				payload: inputData,
			}
		}).catch(error =>{
			console.log('Search Error', error)
		})
	}
}

//::Flag when inside Create Company
export function createCompanyFlag(data){
	return{
		type: CREATE_COMPANY_FLAG,
		payload: data,
	}
}

//::Create Company Mode
export function createCompanyMode(data){
	return{
		type: CREATE_COMPANY_MODE,
		payload: data,
	}
}

//::Submited Mode
export function isSubmitedMode(data){
	return{
		type: IS_SUBMITED_MODE,
		payload: data,
	}
}



//::Create Head Admin
export function createHeadAdminList(data){
	return async (dispatch) =>{
		console.log('Head Admin List', data);

		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/member/companyHeadAdmin', data, headersToken );

		return request.then((response) => {
			console.log(response.data, 'Post Succesfully');
			//::Force Update Consume API
			dispatch(getHeadAdmin(data.companyID));
			dispatch(addPost(response.data));
			return dispatch({
				type: CREATE_HEAD_ADMIN_LIST,
				payload: data,
			})	
		})
		.catch((error => {
			dispatch(addPost(error.response && error.response.data));
			console.log(error.response && error.response.data, 'Post error');
		}))
	}
}

export function validDomain(data){
	return{
		type:VALID_DOMAIN,
		payload: data,
	}
}


export function clickCreateHeadAdmin(data){
	return{
		type:CLICK_CREATE_HEAD_ADMIN,
		payload: data,
	}
}


//::Remove Head Admin
export function removeHeadAdmin(data){
	return async (dispatch)=>{
		console.log('UPDATE ACTION -->', data)

		const url = process.env.REACT_APP_SERVER + '/api/member/companyHeadAdmin';
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.patch(`${url}`, {
			...data,
			companyID: data.companyID,
			user_uuid: data.uuid,
		}, headersToken );

		return request.then((response) => {
			console.log(response.data, 'Removed Succesfully');
			dispatch(getHeadAdmin(data.companyID));
			dispatch(addPost(response.data));
			return dispatch({
				type: REMOVE_HEAD_ADMIN,
				payload: data,
			})
		})
		.catch((error => {
			dispatch(addPost(error.response));
			console.log(error.response, 'Remove error')
		}))
	}
	
}

export function clickRemoveHeadAdmin(data){
	return{
		type:CLICK_REMOVE_HEAD_ADMIN,
		payload: data,
	}
}

export function addCompanyButton() {
	return {
		type: ADD_COMPANY_BUTTON,
	};
}


export function searchFilterCheckbox(data) {
	return {
		type: SET_FILTER_CHECKBOX,
		payload: data
	};
}

export function handleImageEdit(data) {
	return {
		type: HANDLE_IMAGE_EDIT,
		payload: data
	};
}

export function flagClickCompanies(data){
	return{
		type: FLAG_CLICK_COMPANIES,
		payload: data,
	}
}

export function handleEditDetails(data){
	console.log('RECEIVING DATA FROM COMPANY LIST UPDATE CLICK', data)
	return {
			type: HANDLE_EDIT_DETAILS,
			payload: data
	}	
}

export function handleDetails(data){
	return{
		type: HANDLE_DETAILS,
		payload: data,
	}
}

export function isEditable(data){
	return{
		type: IS_EDITABLE,
		payload: data,
	}
}

//::Update Company
export function updateCompany(data){
	return async (dispatch) => {
		console.log('UPDATE ACTION -->', data)
		const url = process.env.REACT_APP_SERVER + '/api/company/';
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.put(`${url}${data.uuid}`, data, headersToken )

		return request.then( response => {
			dispatch(addPost(response.data));
			console.log(response.data, 'Success update');

			return dispatch({
				type: HANDLE_UPDATE_COMPANY,
				payload: response.data,
			})

		})
		.catch((error => {
			dispatch(addPost(error.response.data));
			console.log(error.response.data, 'UPDATE error');
			//alert('Some Error Happened');
		}))
	}
}

//::Handling Response
export function addPost(data){
	return {
		type: HANDLE_COMPANY_RESPONSE,
		payload: data,
	}
}

//::Activate Company
export function activateCompany(data){
	return async (dispatch)=>{
		console.log('ACTIVATE ACTION -->', data)

		const url = process.env.REACT_APP_SERVER + '/api/company/';
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.patch(`${url}${data.uuid}`, 
		{
			...data,
			companyID: data.companyID,
			status: false,
		}, headersToken );

		return request.then(response => {	
			//::Force Update Consume API
			dispatch(getCompany());
			console.log(response.data,'ACTIVATE RESPONSE');
			return dispatch({
				type: HANDLE_ACTIVATE_COMPANY,
				payload: data,
			})
		})
		.catch((error => {
			console.log(error.response, 'ACTIVATE error')
		}))
	}
}

//::Remove Company
export function removeCompany(data){
	return async (dispatch)=>{
		console.log('UPDATE ACTION -->', data)

		const url = process.env.REACT_APP_SERVER + '/api/company/';
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.patch(`${url}${data.uuid}`, {
			...data,
			companyID: data.companyID,
			status: true,
		}, headersToken );

		return request.then((response) => {
			console.log(response.data, 'Removed Succesfully');
			dispatch(getCompany());
			dispatch(addPost(response.data));
			return dispatch({
				type: HANDLE_REMOVE_COMPANY,
				payload: data,
			})
		})
		.catch((error => {
			dispatch(addPost(error.response));
			console.log(error.response, 'Remove error')
		}))
	}
	
}

export function clickRemoveCompany(data){
	return {
		type: CLICK_REMOVE_COMPANY,
		payload: data
	}
}

export function handleFilesUpload(data){
	return{
		type:HANDLE_FILES_UPLOAD,
		payload: data
	}
}

export function handleFilesUploadList(data){
	return{
		type:HANDLE_FILES_UPLOAD_LIST,
		payload: data
	}
}

export function setImgHeadAdmin(data){
	return{
		type: SET_IMG_HEAD_ADMIN,
		payload:data
	}
}

export function headAdminName(data){
	return{
		type: HEAD_ADMIN_NAME,
		payload: data,
	}
}

export function companyName(data) {
	return {
		type: COMPANY_NAME,
		payload: data,
	};
}

export function searchMember(data) {
	return {
		type: MEMBER_SEARCH_TEXT,
		searchMember: data
	};
}

export function openNewContactDialog() {
	return {
		type: OPEN_NEW_CONTACT_DIALOG
	};
}

export function closeNewContactDialog() {
	return {
		type: CLOSE_NEW_CONTACT_DIALOG
	};
}

export function openEditContactDialog(data) {
	return {
		type: OPEN_EDIT_CONTACT_DIALOG,
		data
	};
}

export function closeEditContactDialog() {
	return {
		type: CLOSE_EDIT_CONTACT_DIALOG
	};
}

export function addContact(newContact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/add-contact', {
			newContact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: ADD_CONTACT
				})
			]).then(() => dispatch(getCompany(routeParams)))
		);
	};
}

export function updateContact(contact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/update-contact', {
			contact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: UPDATE_CONTACT
				})
			]).then(() => dispatch(getCompany(routeParams)))
		);
	};
}

export function removeContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACT
				})
			]).then(() => dispatch(getCompany(routeParams)))
		);
	};
}

export function removeContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACTS
				})
			]).then(() => dispatch(getCompany(routeParams)))
		);
	};
}

// export function toggleStarredContact(contactId) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/toggle-starred-contact', {
// 			contactId
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: TOGGLE_STARRED_CONTACT
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getCompany(routeParams)))
// 		);
// 	};
// }

// export function toggleStarredContacts(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/toggle-starred-contacts', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: TOGGLE_STARRED_CONTACTS
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getCompany(routeParams)))
// 		);
// 	};
// }

// export function setContactsStarred(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/set-contacts-starred', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: SET_CONTACTS_STARRED
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getCompany(routeParams)))
// 		);
// 	};
// }

// export function setContactsUnstarred(contactIds) {
// 	return (dispatch, getState) => {
// 		const { routeParams } = getState().addmemberUsersApp.contacts;

// 		const request = axios.post('/api/contacts-app/set-contacts-unstarred', {
// 			contactIds
// 		});

// 		return request.then(response =>
// 			Promise.all([
// 				dispatch({
// 					type: SET_CONTACTS_STARRED
// 				}),
// 				dispatch(getUserData())
// 			]).then(() => dispatch(getCompany(routeParams)))
// 		);
// 	};
// }
